import { Component, effect, inject } from '@angular/core';

import { CoreToastService } from '../toast.service';
import { Signal, computed } from '@angular/core';
import { Toast } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';

@Component({
  selector: 'lib-toast',
  standalone: true,
  imports: [Toast, Button],
  templateUrl: './toast.component.html',
})
export class CoreToastComponent {
  private toastService = inject(CoreToastService);
  private _messageService = inject(MessageService);

}
